

export enum AplosFileState {

    Ready = "ready",
    Uploading = "uploading",
    Processing = "processing",
    Validating = "validating",
    Converting = "converting",
    Failed = "failed"

}